import "core-js/modules/es6.regexp.replace";
import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.search";
/* eslint-disable */
/*客服组件
 *<component-customer-service :is-show-customer.sync="isShowCustomer"></component-customer-service>
 * componentCenter.customerService.getCustomerService(hotelId); 获取客服
 * componentCenter.customerService.loadOrShowCustomerService(); 显示客服弹框
 */
import { toQueryString, pressEvent } from '@ykz/ykz-util/base';
import databus, { Origins } from '@ykz/ykz-http/core';
import { isOtherBrowsers } from '@ykz/ykz-util/platform';
export default {
  name: 'customerService',
  data: function data() {
    return {
      fxbInviteCode: getUrlParams('fxbInviteCode') || '',
      xiaoNengSwitchStatus: 1,
      loadCustomerService: false,
      //渲染客服弹框
      showCustomerService: false,
      //显示客服弹框
      showOutAnimation: false,
      //展示关闭弹框动画

      customer: {},
      //客服信息
      weChatId: getUrlParams('weChatId') || window.weChatId,
      isOther: getUrlParams('isOther') || '',
      //非云客公众号直接通过链接访问所带的参数，用来隐藏二维码
      goodId: getUrlParams('goodId') || '',
      //商品id
      isProductDetailPage: location.href.search(/ticketProductDetails|entranceTicketDetails|specialDetails|showTicketDetails|productDetail/) != -1 ? true : false,
      //是否在产品详情页调用该组件
      isOtherBrowser: isOtherBrowsers() //除微信、app外的第三方浏览器打开页面
    };
  },

  props: {
    isMultipleStore: {
      type: Number
    },
    isShowCustomer: {},
    //是否要展示咨询客服入口
    phone: {},
    //门店联系电话
    info: {
      //客服二维码数据
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  mounted: function mounted() {
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    window.componentCenter.customerService = this;
    console.log('ycf组件初始化：customerService');
  },
  methods: {
    //显示客服弹框
    loadOrShowCustomerService: function loadOrShowCustomerService() {
      // if((this.customer.phone && this.customer.phone.length) && this.customer.xiaoNengSwitchStatus) {
      // 	this.goCustomerServicePage();
      // 	return true;
      // }
      if (this.loadCustomerService) {
        this.showCustomerService = true;
      } else {
        this.loadCustomerService = true;
        this.$nextTick(function () {
          var _this = this;
          this.showCustomerService = true;
          if (this.info.type == 1 || this.info.type == 2) {
            pressEvent('.component-customer-service img.pic-erweima', function () {
              _this.generalAnchors('recWechatCodeOpen');
            });
          }
        });
      }
    },
    //跳转到门店页
    goStorePage: function goStorePage() {
      var that = this;
      window.location.href = '/front/platform/storeList?' + toQueryString({
        weChatId: that.weChatId,
        type: 1,
        productId: that.goodId
      });
    },
    //隐藏弹框
    hideBox: function hideBox() {
      var that = this,
        timer = null;
      this.showOutAnimation = true;
      timer = setTimeout(function () {
        clearTimeout(timer);
        that.showOutAnimation = false;
        that.showCustomerService = false;
      }, 200);
    },
    //跳转到七鱼客服页
    goCustomerServicePage: function goCustomerServicePage() {
      YCF_Plugin.callCustomerService({
        itemid: this.goodId,
        entranceType: 2,
        fromPage: '商详页',
        uname: window.promoterStatusData && window.promoterStatusData.nickName || ''
      });
    },
    //获取客服信息
    getCustomerService: function getCustomerService(hotelId) {
      var that = this;
      databus({
        type: 'get',
        data: {
          hotelId: hotelId,
          goodId: this.goodId
        },
        url: '/apiv2/hotel/getCustomerService',
        success: function success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            that.customer = res.content || {};
            if (that.isOtherBrowser) {
              //第三方浏览器打开，不支持在线客服
              that.xiaoNengSwitchStatus = 0;
            }
          }
        },
        complete: function complete() {
          if (that.phone) {
            //兼容门店电话数据
            that.customer.phone = [that.phone];
          }
          // if(!(that.customer.phone && that.customer.phone.length)) { //没有电话数据时，前端写死一个
          // 	that.customer.phone = ["020-3943-7415"];
          // }
          if (that.info.type == 1 || that.info.type == 2 || that.customer.phone && that.customer.phone.length || that.xiaoNengSwitchStatus) {
            that.$emit('update:isShowCustomer', true);
          }
        }
      });
    },
    //通用锚点事件
    generalAnchors: function generalAnchors(element_content, callback) {
      YCF_Plugin.reportUserAnchors({
        event_id: '520006',
        properties: {
          element_content: element_content,
          item_id: this.goodId
        }
      }).always(callback);
    }
  },
  filters: {
    //去除座机号码的“-”
    getPhone: function getPhone(value) {
      if (value && typeof value == 'string') {
        return value.replace(/-/g, '');
      } else {
        return '';
      }
    }
  }
};